import { render } from "./ViewCode.vue?vue&type=template&id=4fe82782"
import script from "./ViewCode.vue?vue&type=script&lang=js"
export * from "./ViewCode.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\甘小星\\Desktop\\sakai-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__